import { lazy } from "react";

export default [
  {
    exact: true,
    path: ["/:customerName/signature/inbox/", "/:customerName/signature/"],
    component: lazy(() => import("src/views/arkadu/signature/SignatureInbox")),
  },
];
